declare const __VERSION__: string;
declare const __SENTRY_DSN__: string;

export const VERSION: string = __VERSION__;
export const SENTRY_DSN: string = __SENTRY_DSN__;
